import {
  DatePicker,
  DateTimePicker,
  TimePicker,
} from "@progress/kendo-react-dateinputs";
import { Field, FormElement } from "@progress/kendo-react-form";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { Error, Label } from "@progress/kendo-react-labels";
import * as React from "react";
import {
  RoomEditor,
  TherapistEditor,
  TitleEditor,
  TreatmentEditor,
  Location,
  Approver,
  ContactPerson,
  FormCheckbox,
  ShiftLength,
  AmountPerShift,
} from "./editors";
import {
  getMultiShiftEncounterRate,
  calendaeLocationDetails,
} from "../../JobOpportunity/action";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../../hooks/useConfiguration";
import useSessionStorage from "../../../hooks/useSessionStorage";
import * as Toasts from "../../common/Toastify";
import moment from "moment";
import { formatNumberWithoutCommas, handleDecimalValueOnOnChange } from "../../../helpers/regEx";
import { payRateTypeObj } from "../../../helpers/data";

export const CustomFormEditor = (props) => {
  const shiftStartDate = props.valueGetter("Start");
  const defaultStartDate = React.useRef(shiftStartDate);
  const shiftEndDate = props.valueGetter("End");
  const defaultEndDate = React.useRef(shiftEndDate);
  const shiftLength = props.valueGetter("shiftLength");
  const location = props.valueGetter("locationId");
  const billRate = props.valueGetter("billingrate");
  // console.log({billRate});
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const jobCategory = useSelector(
    (state) => state.jobOpportunity.jobInfo.jobCategory
  );
  const payRateType = useSelector((state) => state.jobOpportunity.payRateType);

  const recursionFlag = useSelector(
    (state) => state.jobOpportunity.recursionFlag
  );
  const masterData = useSelector((state) => state.jobOpportunity.masterData);
  const callAproverAndContactPerson = async () => {
    const location = props.valueGetter("locationId");
    // console.log(location);
    props.onChange("jobsContactsList", {
      value: [],
    });
    props.onChange("jobsApproversList", {
      value: [],
    });
    dispatch(calendaeLocationDetails(config.baseUrl, location));
    // const params = {
    //   locationId: location,
    //   jobCategoryId: jobCategory.id,
    //   startTime: moment(shiftStartDate).format("HH:mm:ss"),
    //   endTime: moment(shiftEndDate).format("HH:mm:ss"),
    //   shiftDate: moment(shiftStartDate).format("YYYY-MM-DD"),
    // };
    // dispatch(
    //   getMultiShiftEncounterRate(config.baseUrl, params)
    // ).then(encounterRate => {
    //     if(encounterRate?.getHourlyRates && !encounterRate?.getHourlyRates?.billingRateToDispaly){
    //       props.onChange('billingrate', {
    //         value: "",
    //       });
    //   Toasts.error(`Please add the billing rate`)
    //   return
    // } else {
    //   props.onChange('billingrate', {
    //     value: encounterRate?.getHourlyRates?.billingRateToDispaly,
    //   });
    // }
    // });
  };

  const updateShiftTime = ({
    currentValue,
    updateField,
    shiftStartTime,
    masterData,
  }) => {
    if (updateField === "shiftLength") {
      const startTime = moment(shiftStartTime, "hh:mm");
      const endTime = moment(currentValue, "hh:mm");
      const InMinutes = moment.duration(endTime.diff(startTime)).asMinutes();
      const result = masterData?.find((item) => item?.id === InMinutes);
      const lastItem = masterData.at(-1);
      let updatePreferredShift;
      if (result) {
        updatePreferredShift = result?.id;
      } else if (InMinutes > lastItem?.id) {
        updatePreferredShift = lastItem?.id;
      }
      if (updatePreferredShift) {
        props.onChange(updateField, {
          value: updatePreferredShift,
        });
      }
    }
    if (updateField === "End") {
      const hours = Math.floor(parseInt(currentValue) / 60);
      const minutes = parseInt(parseInt(currentValue)) % 60;
      const actualEndTime = moment(shiftStartTime)
        .add(hours, "hours")
        .add(minutes, "minute");
      console.log({ actualEndTime });
      if (actualEndTime) {
        props.onChange(updateField, {
          value: new Date(actualEndTime),
        });
      }
    }
  };

  const changeEndDate = (target) => {
    const start = props.valueGetter("Start");
    updateShiftTime({
      currentValue: target.value,
      updateField: "End",
      shiftStartTime: start,
      masterData: [],
    });
    const end = props.valueGetter("End");

    const params = {
      locationId: location,
      jobCategoryId: jobCategory.id,
      startTime: moment(start).format("HH:mm:ss"),
      endTime: moment(end).format("HH:mm:ss"),
      shiftDate: moment(start).format("YYYY-MM-DD"),
    };
    dispatch(getMultiShiftEncounterRate(config.baseUrl, params)).then(
      (encounterRate) => {
        if (
          encounterRate?.getHourlyRates &&
          !encounterRate?.getHourlyRates?.billingRateToDispaly
        ) {
          props.onChange("billingrate", {
            value: "",
          });
          Toasts.error(`Please add the billing rate`);
          return;
        } else {
          props.onChange("billingrate", {
            value: encounterRate?.getHourlyRates?.billingRateToDispaly,
          });
        }
      }
    );
  };
  const changeShiftLength = (target) => {
    const start = props.valueGetter("Start");
    const end = props.valueGetter("End");
    const isStartGreaterEnd = start > end;
    const diffDateTimes = moment.duration(moment(end).diff(moment(start)));
    const diffHours = diffDateTimes.asHours();
    const dayInHours = 24;
    const isEndGreaterADayStart = diffHours > dayInHours;
    const shiftLength = props.valueGetter("shiftLength") ?? 15;
    if (target === "Start") {
      if (isStartGreaterEnd || isEndGreaterADayStart) {
        const errorMsg = isStartGreaterEnd
          ? "Start date should not be greater than end date"
          : isEndGreaterADayStart
          ? "The difference between the start and end days should not be greater than a day"
          : "";
        Toasts.error(errorMsg);
        props.onChange("Start", { value: shiftStartDate });
      } else {
        updateShiftTime({
          currentValue: shiftLength,
          updateField: "End",
          shiftStartTime: start,
          masterData: [],
        });
      }
    } else if (target === "End") {
      if (isStartGreaterEnd || isEndGreaterADayStart) {
        const errorMsg = isStartGreaterEnd
          ? "Start date should not be greater than end date"
          : isEndGreaterADayStart
          ? "The difference between the start and end days should not be greater than a day"
          : "";
        Toasts.error(errorMsg);
        props.onChange("End", { value: shiftEndDate });
      } else {
        updateShiftTime({
          currentValue: end,
          updateField: "shiftLength",
          shiftStartTime: start,
          masterData: masterData?.allPreferedShifts,
        });
      }
    }

    const params = {
      locationId: location,
      jobCategoryId: jobCategory.id,
      startTime: moment(start).format("HH:mm:ss"),
      endTime: moment(end).format("HH:mm:ss"),
      shiftDate: moment(start).format("YYYY-MM-DD"),
    };
    dispatch(getMultiShiftEncounterRate(config.baseUrl, params)).then(
      (encounterRate) => {
        if (
          encounterRate?.getHourlyRates &&
          !encounterRate?.getHourlyRates?.billingRateToDispaly
        ) {
          props.onChange("billingrate", {
            value: "",
          });
          Toasts.error(`Please add the billing rate`);
          return;
        } else {
          props.onChange("billingrate", {
            value: encounterRate?.getHourlyRates?.billingRateToDispaly,
          });
        }
      }
    );
  };

  const amountChange = (e) => {
    const removeExistComma = formatNumberWithoutCommas(e.value);
    const decimalConversion = handleDecimalValueOnOnChange(removeExistComma);
    if (decimalConversion) {
      props.onChange("payRateOccurrenceAmount", {
        value: handleDecimalValueOnOnChange(decimalConversion),
      });
    }
  };

  return (
    <FormElement horizontal={false} style={{ justifyContent: "none" }}>
      <div className="k-form-field">
        <Label>Title</Label>
        <div className="k-form-field-wrap">
          <Field
            name={"Title"}
            component={props.titleEditor || Input}
            as={Input}
            // format="t"
          />
        </div>
      </div>
      <div className="k-form-field">
        <Label>
          Location Name <span className="required">* </span>
        </Label>
        <div className="k-form-field-wrap">
          <Field
            name={"locationId"}
            component={Location}
            onChange={callAproverAndContactPerson}
          />
          {/* {props.errors.AppointmentType && (
            <Error>{props.errors.AppointmentType}</Error>
          )} */}
        </div>
      </div>
      <div className="kendo-custom-field">
        <div className="k-form-field">
          <Label>
            Contact persons <span className="required">* </span>
          </Label>
          <div className="k-form-field-wrap">
            <Field
              name={"jobsContactsList"}
              component={ContactPerson}
              locationId={props.valueGetter("locationId")}
              // onChange={callAproverAndContactPerson}
            />
            {props.errors.jobsContactsList && (
              <Error>{props.errors.jobsContactsList}</Error>
            )}
          </div>
        </div>
        <div className="k-form-field">
          <Label>
            Approval users <span className="required">* </span>
          </Label>
          <div className="k-form-field-wrap">
            <Field
              name={"jobsApproversList"}
              component={Approver}
              locationId={props.valueGetter("locationId")}
              // onChange={callAproverAndContactPerson}
            />
            {props.errors.jobsApproversList && (
              <Error>{props.errors.jobsApproversList}</Error>
            )}
          </div>
        </div>
      </div>
      <div className="kendo-custom-field">
        {/* <div className="k-form-field" style={{ width: '50%' }}>
            <Label>Billing Rate  <span className='required'>* </span></Label>
            <div className="k-form-field-wrap">
              <Field
                name={'billingrate'}
                component={Input}
                as={Input}
                disabled={true}
              />
              {props.errors.billingRate && (
                <Error>{props.errors.billingRate}</Error>
              )}
            </div>
          </div> */}
        <div className="k-form-field" style={{ width: "50%" }}>
          <Label>
            Shift Length <span className="required">* </span>
          </Label>
          <div className="k-form-field-wrap">
            <Field
              name={"shiftLength"}
              component={ShiftLength}
              onChange={changeEndDate}
            />
            {props.errors.ShiftLength && (
              <Error>{props.errors.ShiftLength}</Error>
            )}
          </div>
        </div>
        {payRateType === payRateTypeObj.manualCal && (
          <div className="k-form-field" style={{ width: "50%" }}>
            <Label>
              Amount Per Shift ($) <span className="required">* </span>
            </Label>
            <div className="k-form-field-wrap">
              {/* <Field
              name={"payRateOccurrenceAmount"}
              component={props.payRateOccurrenceAmount || Input}
              as={Input}
              // format="t"
            /> */}
              <Field
                id={"payRateOccurrenceAmount"}
                name={"payRateOccurrenceAmount"}
                component={AmountPerShift}
                onChange={amountChange}
              />
              {props.errors.payRateOccurrenceAmount && (
                <Error>{props.errors.payRateOccurrenceAmount}</Error>
              )}
            </div>
          </div>
        )}
      </div>
      <div className="kendo-custom-field">
        <div className="k-form-field" style={{ width: "50%" }}>
          <Label>Start</Label>
          <div className="k-form-field-wrap">
            <Field
              // disabled={true}
              name={"Start"}
              component={props.startEditor || DatePicker}
              as={DateTimePicker}
              rows={1}
              width={"240px"}
              // format="t"
              onChange={() => changeShiftLength("Start")}
            />
          </div>
        </div>
        <div className="k-form-field" style={{ width: "50%" }}>
          <Label>End</Label>
          <div className="k-form-field-wrap">
            <Field
              name={"End"}
              component={props.endEditor || DatePicker}
              as={DateTimePicker}
              rows={1}
              width={"240px"}
              // format="t"
              onChange={() => changeShiftLength("End")}
            />
          </div>
        </div>
      </div>
      <div className="k-form-field">
        <Field
          id={"editDay"}
          name={"editDay"}
          label={`All ${moment(shiftStartDate).format("dddd")}s`}
          component={FormCheckbox}
          startDate={shiftStartDate}
          endDate={shiftEndDate}
          defaultStartDate={defaultStartDate}
          defaultEndDate={defaultEndDate}
        />
      </div>

      {/* <div className="k-form-field">
        <Label>Patient Name</Label>
        <div className="k-form-field-wrap">
          <Field name={'Patient'} component={TitleEditor} />
          {props.errors.Patient && <Error>{props.errors.Patient}</Error>}
        </div>
      </div>
      <div className="k-form-field">
        <Label>Therapist</Label>
        <div className="k-form-field-wrap">
          <Field name={'Therapist'} component={TherapistEditor} />
        </div>
      </div>
      <div className="k-form-field">
        <Label>Treatment</Label>
        <div className="k-form-field-wrap">
          <Field name={'Treatment'} component={TreatmentEditor} />
          {props.errors.Treatment && <Error>{props.errors.Treatment}</Error>}
        </div>
      </div>
      <div className="k-form-field">
        <Label>Note</Label>
        <div className="k-form-field-wrap">
          <Field name={'Note'} component={TextArea} rows={1} />
        </div>
      </div>
       <div className="k-form-field">
        <Label>Room</Label>
        <div className="k-form-field-wrap">
          <Field name="Room" component={RoomEditor} />
        </div>
      </div> */}
    </FormElement>
  );
};
